import { Alert } from '@mui/material';

import { LoadingSpinner } from '@modules/_shared/components/LoadingSpinner';

export const QueryStateView = ({
  loading,
  error,
}: {
  loading: boolean;
  error: unknown;
}) => {
  if (loading) {
    return <LoadingSpinner sx={{ height: '100%' }} />;
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        <pre>{JSON.stringify(error, null, 2)}</pre>
      </Alert>
    );
  }

  return null;
};
